<div class="card card-box mb-5">
    <div class="no-gutters row">
        <div class="col-xl-6 pt-3">
            <div class="divider-v divider-v-md"></div>
            <div class="row mt-2">
                <div class="col">
                    <div class="text-center">
                        <div>
                            <fa-icon [icon]="['far', 'user']" class="font-size-xxl text-success"></fa-icon>
                        </div>
                        <div class="mt-2 line-height-sm">
                            <b class="font-size-lg">2,345</b>
                            <span class="text-black-50 d-block">users</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="text-center">
                        <div>
                            <fa-icon [icon]="['far', 'chart-bar']" class="font-size-xxl text-info"></fa-icon>
                        </div>
                        <div class="mt-2 line-height-sm">
                            <b class="font-size-lg">$9,693</b>
                            <span class="text-black-50 d-block">revenue</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider mt-3 mb-3"></div>
            <div class="text-center">
                <a [routerLink]=""
                   class="m-3 btn btn-primary p-0 d-inline-block text-center font-size-xxl d-70 rounded"
                  tooltip="Menu Example"
                >
                    <fa-icon [icon]="['far', 'building']" class="font-size-lg"></fa-icon>
                </a>
                <a [routerLink]=""
                   class="m-3 btn btn-success p-0 d-inline-block text-center font-size-xxl d-70 rounded"
                  tooltip="Menu Example"
                >
                    <fa-icon [icon]="['far', 'lightbulb']" class="font-size-lg"></fa-icon>
                </a>
                <a [routerLink]=""
                   class="m-3 btn btn-danger p-0 d-inline-block text-center font-size-xxl d-70 rounded"
                  tooltip="Menu Example"
                >
                    <fa-icon [icon]="['far', 'object-group']" class="font-size-lg"></fa-icon>
                </a>
            </div>
        </div>
        <div class="col-xl-6 pt-3">
            <div class="row mt-2">
                <div class="col">
                    <div class="text-center">
                        <div>
                            <fa-icon [icon]="['far', 'user']" class="font-size-xxl text-success"></fa-icon>
                        </div>
                        <div class="mt-2 line-height-sm">
                            <b class="font-size-lg">2,345</b>
                            <span class="text-black-50 d-block">users</span>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="text-center">
                        <div>
                            <fa-icon [icon]="['far', 'chart-bar']" class="font-size-xxl text-info"></fa-icon>
                        </div>
                        <div class="mt-2 line-height-sm">
                            <b class="font-size-lg">$9,693</b>
                            <span class="text-black-50 d-block">revenue</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider mt-3 mb-3"></div>
            <div class="text-center">
                <a [routerLink]=""
                   class="m-3 btn btn-primary border-0 p-0 shadow-sm bg-sunny-morning d-inline-block text-center text-white font-size-xxl d-70 rounded"

                  tooltip="Menu Example">
                    <fa-icon [icon]="['far', 'comment-dots']" class="font-size-lg"></fa-icon>
                </a>
                <a [routerLink]=""
                   class="m-3 btn btn-primary border-0 p-0 shadow-sm bg-strong-bliss d-inline-block text-center text-white font-size-xxl d-70 rounded"

                  tooltip="Menu Example">
                    <fa-icon [icon]="['far', 'question-circle']" class="font-size-lg"></fa-icon>
                </a>
                <a [routerLink]=""
                   class="m-3 btn btn-primary border-0 p-0 shadow-sm bg-night-sky d-inline-block text-center text-white font-size-xxl d-70 rounded"

                  tooltip="Menu Example">
                    <fa-icon [icon]="['far', 'lightbulb']" class="font-size-lg"></fa-icon>
                </a>
            </div>
        </div>
    </div>
</div>
